import { render, staticRenderFns } from "./artefact-editor-toolbar.vue?vue&type=template&id=0275fdb4&scoped=true&"
import script from "./artefact-editor-toolbar.vue?vue&type=script&lang=ts&"
export * from "./artefact-editor-toolbar.vue?vue&type=script&lang=ts&"
import style0 from "./artefact-editor-toolbar.vue?vue&type=style&index=0&id=0275fdb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0275fdb4",
  null
  
)

export default component.exports